import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';
import { ApiError } from '@/shared/api/api-error';

/**
 * Aplica no formulário os erros por campo do problem+json. `toFormField` traduz o caminho do
 * contrato para o campo do formulário quando eles diferem (ex.: `address.city` → `city`).
 * Devolve `true` se algum erro foi associado a um campo conhecido.
 */
export function applyFieldErrors<TValues extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<TValues>,
  knownFields: readonly Path<TValues>[],
  toFormField: (field: string) => string = (field) => field,
): boolean {
  if (!(error instanceof ApiError)) return false;
  const known = new Set<string>(knownFields);
  let applied = false;
  for (const [field, message] of Object.entries(error.fieldErrors)) {
    const formField = toFormField(field);
    if (known.has(formField)) {
      setError(formField as Path<TValues>, { type: 'server', message });
      applied = true;
    }
  }
  return applied;
}
